import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { format } from 'date-fns';
import { fetchApi } from '../../lib/apiClient';
import { CreateDiaryData, Diary, UpdateDiaryData } from '../../types/diary';

// 存储当前选中日期的日记
export const currentDiaryAtom = atomWithReset<Diary | null>(null);

// 存储是否正在加载
export const isDiaryLoadingAtom = atom(false);

// 获取指定日期的日记
export const fetchDiaryByDateAtom = atom(
  null,
  async (get, set, date: Date) => {
    set(isDiaryLoadingAtom, true);
    set(currentDiaryAtom, null);
    try {
      const formattedDate = format(date, 'yyyy-MM-dd');
      const data = await fetchApi<Diary | null>('diary/get', {
        method: 'POST',
        body: { date: formattedDate },
      });

      set(currentDiaryAtom, data);
    } catch (error) {
      set(currentDiaryAtom, null);
    } finally {
      set(isDiaryLoadingAtom, false);
    }
  }
);

// 更新或创建日记
export const upsertDiaryAtom = atom(
  null,
  async (get, set, diaryData: CreateDiaryData | UpdateDiaryData) => {
    set(isDiaryLoadingAtom, true);
    try {
      const data = await fetchApi<Diary>('diary/upsert', {
        method: 'POST',
        body: diaryData,
      });

      set(currentDiaryAtom, data);
    } catch (error) {
    } finally {
      set(isDiaryLoadingAtom, false);
    }
  }
);

// 删除日记
export const deleteDiaryAtom = atom(
  null,
  async (get, set, date: Date) => {
    set(isDiaryLoadingAtom, true);
    try {
      const formattedDate = format(date, 'yyyy-MM-dd');
      await fetchApi('diary/delete', {
        method: 'POST',
        body: { date: formattedDate },
      });

      set(currentDiaryAtom, null);
      return true;
    } catch (error) {
      set(currentDiaryAtom, null);
      return false;
    } finally {
      set(isDiaryLoadingAtom, false);
    }
  }
); 